/* HOULe 2026.10.16 カートの「会員登録のご案内」（未ログインのお客様のみ表示） */
(function () {
  if (window.HOULE_CUSTOMER) return;
  var NOTE = 'HOULeShopは<strong>メーカー指定の正規販売店</strong>のため、ご購入時に<strong>無料の会員登録</strong>をお願いしています。<br>メールアドレスに届く確認コードを入力するだけで、1分ほどで完了します（パスワードは不要です）。';
  var CSS = '.houle-member-note{margin:0 0 12px;padding:10px 12px;border:1px solid #3F5B44;border-radius:6px;background:#F3F1EA;color:#22261F;font-size:12px;line-height:1.7;text-align:left}';
  function addStyle() {
    if (document.getElementById('houle-member-style')) return;
    var s = document.createElement('style'); s.id = 'houle-member-style'; s.textContent = CSS;
    document.head.appendChild(s);
  }
  function fix() {
    document.querySelectorAll('input[name="checkout"], button[name="checkout"]').forEach(function (btn) {
      var box = btn.parentNode;
      if (!box) return;
      var first = box.firstElementChild;
      if (first && first.classList.contains('houle-member-note')) return;
      var n = box.querySelector(':scope > .houle-member-note');
      if (!n) { n = document.createElement('div'); n.className = 'houle-member-note'; n.innerHTML = NOTE; }
      box.insertBefore(n, box.firstChild);
    });
  }
  var queued = false;
  function schedule() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; fix(); }); }
  function start() {
    addStyle(); fix();
    new MutationObserver(schedule).observe(document.body, { subtree: true, childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
